export const actionSymbol = 'a';
export const actionOnSymbol = 'aO';
export const computedSymbol = 'c';
export const persistSymbol = 'p';
export const reducerSymbol = 'r';
export const thunkOnSymbol = 'tO';
export const thunkSymbol = 't';
